<template>
  <div v-if="homeReviewBlock" class="feature-reviews">
    <div v-html="homeReviewBlock"></div>
  </div>
  <!-- eslint-disable vue/no-v-html -->
  <div v-else-if="homeReviews" class="featured-reviews">
    <div class="featured-reviews__info">
      <div class="featured-reviews__info-wrapper">
        <div class="featured-reviews__stars">
          <StarFilled v-for="index in 4" :key="index" />
          <StarHalf />
          <span class="featured-reviews__reviews-count">
            ({{ $t('featured_reviews.reviews_count') }})
          </span>
        </div>
        <div class="featured-reviews__title">
          <h3 class="featured-reviews__title-main">
            {{ $t('featured_reviews.title') }}
            <small class="featured-reviews__title-small">
              {{ $t('featured_reviews.title_small') }}
            </small>
          </h3>
          <p class="featured-reviews__description">
            {{ $t('featured_reviews.paragraph') }}
          </p>
          <v-link
            :label="$t('see_more.see_more_text')"
            :url="$isBrStore ? '/reviews-gocase' : '/reviews'"
          />
        </div>
      </div>
    </div>

    <div class="featured-reviews__nav">
      <button
        v-show="translateX != 0"
        class="featured-reviews__nav-item featured-reviews__nav-item--left"
        @click="navGallery(1)"
      >
        <ArrowLeft class="featured-reviews__arrow" />
      </button>
      <button
        class="featured-reviews__nav-item featured-reviews__nav-item--right"
        @click="navGallery(-1)"
      >
        <ArrowRight class="featured-reviews__arrow" />
      </button>
    </div>

    <div class="featured-reviews__gallery">
      <div v-html="homeReviews"></div>
    </div>
  </div>
</template>

<script>
import ArrowLeft from '~/components/icons/arrow-left/ArrowLeft'
import ArrowRight from '~/components/icons/arrow-right/ArrowRight'
import StarFilled from '~/components/icons/star/StarFilled'
import StarHalf from '~/components/icons/star/StarHalf'
import VLink from '~/components/v-link/VLink'

import scrollingNavigator from '~/mixins/scrolling-navigator'

export default {
  components: {
    ArrowLeft,
    ArrowRight,
    StarFilled,
    StarHalf,
    VLink,
  },
  mixins: [scrollingNavigator],
  props: {
    homeReviews: {
      type: String,
      required: true,
    },
    homeReviewBlock: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      listClassName: 'featured-reviews__list',
    }
  },
}
</script>

<style lang="scss">
.featured-reviews {
  background-color: white;
  padding-top: 20px;

  .featured-reviews__title {
    padding-left: 15px;
    padding-right: 15px;
  }

  .featured-reviews__stars {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    justify-content: center;
  }
  .featured-reviews__reviews-count {
    margin-left: 15px;
  }

  .featured-reviews__title-main {
    margin: 0 0 15px;
    font-size: 27px;
    text-align: inherit;
  }
  .featured-reviews__title-small {
    display: block;
    font-size: 60%;
  }

  .featured-reviews__description {
    font-size: 16px;
    line-height: 1.6;
  }

  .featured-reviews__info {
    text-align: center;
    padding: 30px 0 0;
  }

  .featured-reviews__nav {
    display: none;
  }

  .featured-reviews__gallery {
    overflow-x: auto;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .featured-reviews__list {
    display: grid;
    grid-template-columns: repeat(4, 315px);
    grid-row-gap: 15px;
    margin-top: 20px;
    padding: 0 15px 15px;
  }

  .featured-reviews__item {
    padding-right: 15px;
  }

  .featured-reviews__arrow {
    width: 23px;
    fill: $v4_color_primary;
    transition: all 0.2s ease-in-out;
  }

  @media (min-width: $v4_desktop) {
    padding: 60px 0;
    display: flex;
    align-items: center;
    position: relative;

    .featured-reviews__stars {
      justify-content: left;
      padding-left: 15px;
    }

    .featured-reviews__title-main {
      font-size: 48px;
      line-height: 62px;
    }

    .featured-reviews__description {
      font-size: 20px;
    }

    .featured-reviews__info {
      width: 50%;
      min-width: 50%;
      flex-grow: 0;
      box-sizing: border-box;
      padding-bottom: 30px;
      padding-left: 60px;
      padding-right: 30px;
      text-align: left;

      .featured-reviews__info-wrapper {
        max-width: 450px;
        margin-left: auto;
        margin-right: auto;
      }
    }

    .featured-reviews__nav {
      display: block;

      .featured-reviews__nav-item {
        position: absolute;
        top: 50%;
        margin-top: -54px;
        width: 70px;
        height: 70px;
        line-height: 78px;
        z-index: 5;
        text-align: center;
        border-radius: 50%;
        border: 0;
        background-color: rgba(229, 235, 235, 0.5);
        cursor: pointer;

        &:focus {
          outline: 0;
        }
        &:hover {
          background-color: rgba(229, 235, 235, 1);
        }

        &--left {
          left: calc(50% - 100px);
        }
        &--right {
          right: 60px;
        }
      }
    }

    .featured-reviews__gallery {
      width: 50%;
      position: relative;
      overflow: hidden;
    }

    .featured-reviews__list {
      margin-top: 40px;
      grid-row-gap: 30px;
      grid-template-columns: repeat(4, 410px);
      padding: 0 0 30px 0;
      transition: transform 400ms cubic-bezier(0.165, 0.84, 0.44, 1) 0s;
    }
  }

  .featured-reviews-item {
    background-color: #f5fbfb;
    padding: 15px;
    min-height: 230px;
    width: 300px;

    .featured-reviews-item__header {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .featured-reviews-item__user-photo {
        border-radius: 50%;
        height: 50px;
        width: 50px;
        display: block;
        margin-right: 15px;
      }

      .featured-reviews-item__header-text {
        flex-grow: 1;
      }

      .featured-reviews-item__name {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 3px;
      }

      .featured-reviews-item__icon {
        margin-left: 15px;
        padding-right: 10px;
      }
    }

    .featured-reviews-item__text {
      font-size: 18px;
      line-height: 1.6;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }

    @media (min-width: $v4_desktop) {
      width: 375px;
    }
  }
}
</style>
